var map = {
	"./en/Account": 182,
	"./en/Account.js": 182,
	"./en/Accounts": 4091,
	"./en/Accounts.js": 4091,
	"./en/ComparePage": 3745,
	"./en/ComparePage.js": 3745,
	"./en/FiscalYears": 7212,
	"./en/FiscalYears.js": 7212,
	"./en/GeneralSettings": 3047,
	"./en/GeneralSettings.js": 3047,
	"./en/Home": 5290,
	"./en/Home.js": 5290,
	"./en/Inventory": 9614,
	"./en/Inventory.js": 9614,
	"./en/Item": 7591,
	"./en/Item.js": 7591,
	"./en/Items": 9995,
	"./en/Items.js": 9995,
	"./en/Login": 1316,
	"./en/Login.js": 1316,
	"./en/MaterialJournals": 6139,
	"./en/MaterialJournals.js": 6139,
	"./en/MaterialSimulation": 7088,
	"./en/MaterialSimulation.js": 7088,
	"./en/Navbar": 930,
	"./en/Navbar.js": 930,
	"./en/ProductionJournals": 5161,
	"./en/ProductionJournals.js": 5161,
	"./en/PurchaseSimulation": 729,
	"./en/PurchaseSimulation.js": 729,
	"./en/Purchases": 2047,
	"./en/Purchases.js": 2047,
	"./en/Receiving": 6606,
	"./en/Receiving.js": 6606,
	"./en/Role": 187,
	"./en/Role.js": 187,
	"./en/RolesManagement": 7259,
	"./en/RolesManagement.js": 7259,
	"./en/Sales": 1829,
	"./en/Sales.js": 1829,
	"./en/Statistics": 1238,
	"./en/Statistics.js": 1238,
	"./en/TabSimulationMaterial": 9561,
	"./en/TabSimulationMaterial.js": 9561,
	"./es/Account": 5039,
	"./es/Account.js": 5039,
	"./es/Accounts": 9691,
	"./es/Accounts.js": 9691,
	"./es/ComparePage": 3475,
	"./es/ComparePage.js": 3475,
	"./es/FiscalYears": 2291,
	"./es/FiscalYears.js": 2291,
	"./es/GeneralSettings": 8886,
	"./es/GeneralSettings.js": 8886,
	"./es/Home": 999,
	"./es/Home.js": 999,
	"./es/Inventory": 4031,
	"./es/Inventory.js": 4031,
	"./es/Item": 691,
	"./es/Item.js": 691,
	"./es/Items": 8123,
	"./es/Items.js": 8123,
	"./es/Login": 5380,
	"./es/Login.js": 5380,
	"./es/MaterialJournals": 6969,
	"./es/MaterialJournals.js": 6969,
	"./es/MaterialSimulation": 5350,
	"./es/MaterialSimulation.js": 5350,
	"./es/Navbar": 717,
	"./es/Navbar.js": 717,
	"./es/ProductionJournals": 589,
	"./es/ProductionJournals.js": 589,
	"./es/PurchaseSimulation": 5130,
	"./es/PurchaseSimulation.js": 5130,
	"./es/Purchases": 7051,
	"./es/Purchases.js": 7051,
	"./es/Receiving": 8254,
	"./es/Receiving.js": 8254,
	"./es/Role": 4300,
	"./es/Role.js": 4300,
	"./es/RolesManagement": 1387,
	"./es/RolesManagement.js": 1387,
	"./es/Sales": 2067,
	"./es/Sales.js": 2067,
	"./es/Statistics": 4964,
	"./es/Statistics.js": 4964,
	"./es/TabSimulationMaterial": 4115,
	"./es/TabSimulationMaterial.js": 4115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2225;